import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { postInspectionRequest } from "../../../../../redux/action/inspectionRequest";
import { ClipLoader } from "react-spinners";
import Skeleton from "react-loading-skeleton";
import InspectionFeild from "./children/InspectionFeild";
import InspectionTableforOfferId from "./children/InspectionTableforOfferId";
import AuctionTimeAndLocation from "./children/AuctionTimeAndLocation";
import { singleAuctionDetails } from "../../../../../redux/action/singleAuction";

function RequestInspection() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const loadValue = useSelector((state) => state.loading);
  const [inspectionStoreDetails, setInspectionStoreDetails] = useState({
    inspectionDate: "",
    inspectionLocation: "",
    numberOfPeople: null,
    inspectionBy: "",
    contactPerson: "",
    offers: [],
  });
  const [checkedValue, setCheckedValue] = useState([]);
  const dispatch = useDispatch();
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    const userSelectLits = checkedValue?.map((offer) => offer._id);
    setInspectionStoreDetails((prevState) => ({
      ...prevState,
      offers: userSelectLits,
    }));
  }, [checkedValue]);

  const validateFields = () => {
    const {
      inspectionDate,
      inspectionLocation,
      numberOfPeople,
      inspectionBy,
      contactPerson,
    } = inspectionStoreDetails;
    return (
      inspectionDate &&
      inspectionLocation &&
      numberOfPeople &&
      inspectionBy &&
      contactPerson &&
      checkedValue?.length !== 0
    );
  };

  const handleSubmitInspectRequest = () => {
    dispatch(postInspectionRequest(inspectionStoreDetails, id,navigate))
   
  };

  return (
    <div className="">
      <span className="valign-wrapper" style={{ gap: "15px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
        <h4>Inspection Request</h4>
      </span>
      <div
        className={`cover white z-depth-1 ${
          isMobile ? "p-1" : "p-2"
        } container flex column gap-1`}
      >
        <b className="font-20px font-weight-600" style={{ flex: "0.96" }}>
          Auction ID:{" "}
          <span className="cercle-purple-text">
            {loading ? <Skeleton width={300} /> : singleAuctionData?.auctionId}
          </span>
        </b>

        <div className={`cover `} style={{ padding: isTablet ? "" : "1rem" }}>
          <AuctionTimeAndLocation
            auctioDetailsData={singleAuctionData}
            loading={loading}
          />
        </div>
        <InspectionFeild
          inspectionStoreDetails={inspectionStoreDetails}
          setInspectionStoreDetails={setInspectionStoreDetails}
          locations={singleAuctionData?.inspectionSchedule?.inspectionLocation}
          lastDate={singleAuctionData?.auctionSchedule?.startDate}
        />
        <div>
          <h3
            className={` flex justify-center cercle-purple-text font-weight-600`}
          >
            List of Lot’s
          </h3>
          <InspectionTableforOfferId
            checkedValue={checkedValue}
            setCheckedValue={setCheckedValue}
            totalItem={10}
          />

          <div className="flex justify-center mt-3 ">
            <button
              className={`button-style  pointer ${
                validateFields() ? "white-text cercle-purple" : "grey lighten-2"
              }`}
              style={{ padding: "12px 35px" }}
              disabled={!validateFields()}
              onClick={handleSubmitInspectRequest}
            >
              {loadValue?.loading ? (
                <ClipLoader color="#fff" size={20} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestInspection;
